import cx from 'classnames';
import { CDN_CLRSAVE_URL } from '../../constants';
import { Router } from '../../configs/routes';
import amcStyles from '../../styles/amcs.scss';
import { Amc } from '../../models/singleFundPages';

interface Props {
  amc: Amc;
}

function AmcItem(props: Props) {
  const { amc } = props;

  const handleClick = (e: any) => {
    e.stopPropagation();
    Router.pushRoute(`/mutual-funds/${amc.slug}`);
  };

  return (
    <div className={amcStyles['amcCard']} onClick={handleClick}>
      <div className={cx('mt10', amcStyles['amcImageContainer'])}>
        <img
          className={amcStyles['amc-image']}
          src={`${CDN_CLRSAVE_URL}/clearsave${amc.logoImgUrl}`}
          alt={amc.amcName}
        />
      </div>
      <div className={'mt10'}>{amc.amcName}</div>
    </div>
  );
}

export default AmcItem;



// WEBPACK FOOTER //
// ./components/amc/amcItem.tsx